import { useEffect, useRef } from "react";
import { initTelegramWebApp } from "./utils/telegramUtils";
import AppRouter from "./routes/AppRouter";
import LanguageBootstrapper from "./components/layout/LanguageBootstrapper";
import { useHtmlLang } from "./hooks/useHtmlLang";

export function App() {
    const didInitRef = useRef(false);
    useHtmlLang(); // Update HTML lang attribute when language changes

    useEffect(() => {
        if (didInitRef.current) return;
        didInitRef.current = true;
        initTelegramWebApp();
    }, []);

    return (
        <>
            <LanguageBootstrapper />
            <AppRouter />
        </>
    )
}

export default App;
